/**
 * Non-secret client hint that the user completed login/signup in this browser.
 * Real auth is the httpOnly cookie on the API origin; this only gates UI checks.
 */
export const SESSION_HINT_KEY = 'exituity_session'

/**
 * Pass as React Router `navigate('/login', { state: LOGIN_NAV_SKIP_SESSION_PROBE })` after logout
 * so the login screen does not call GET /api/users/me (cookie is already gone).
 */
export const LOGIN_NAV_SKIP_SESSION_PROBE = Object.freeze({ skipLoginSessionProbe: true })

/** Same as stored session hint from login/signup — do not treat cached `user` JSON alone as proof of session. */
export function hasExplicitLoginSessionHint() {
  try {
    return localStorage.getItem(SESSION_HINT_KEY) === '1'
  } catch (e) {
    return false
  }
}

export function setSessionHint() {
  try {
    localStorage.setItem(SESSION_HINT_KEY, '1')
  } catch (e) {
    /* ignore */
  }
}

export function clearSessionHint() {
  try {
    localStorage.removeItem(SESSION_HINT_KEY)
  } catch (e) {
    /* ignore */
  }
}

/**
 * Same as {@link hasExplicitLoginSessionHint}: login/signup set `exituity_session` only.
 * Cached `user` in localStorage is not used — session is the httpOnly cookie; use GET /api/users/me or credentialed fetches.
 */
export function hasSessionHint() {
  return hasExplicitLoginSessionHint()
}
